export default __webpack_public_path__ + "static/media/Belt of the Death God.8a983af9.jpg";